// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"_2-z","displaySixCardTiles":"a3-z"};